<template>
  <ValidationObserver v-slot="{ invalid }" ref="observer">
  <div class="min-h-full flex items-center justify-center mt-12">
    <div class="container-padded w-2/5 space-y-8 shadow-md sm:p-12">
      <article>
        <header>
          <h2 class="text-center mb-4">
<!--            <svg-vue icon="salesium-logo" class="w-8 h-8 inline-block mr-3" />-->
              Congrats on going Pro!
          </h2>
        </header>

        <div class="ml-10">
<!--          <p class="text-center text-base mb-5">
              Thank you for choosing to create a free Pro account!
          </p>
-->
                <p class="text-center text-hint italic mb-5 -mt-3">
                    <span class="text-red-500">*</span> indicates a required field
                </p>
                <form @submit.prevent="submitChanges" class="space-y-6">
                <!--      <div class="grid grid-cols-6 gap-6">
                        <div class="col-span-6 sm:col-span-3">
                          <ValidationProvider rules="required" v-slot="{ classes, errors }">
                            <div class="control is-required" :class="{...classes, 'is-server-invalid': validationErrors['firstName']}">
                              <label for="businessName">Business Name</label>
                              <input
                                id="businessName"
                                name="businessName"
                                type="text"
                                autocomplete="business-name"
                                class="input-field block w-full"
                                v-model="formData.businessName"
                                @click="clearValidationErrors"
                              />
                              <span class="text-red-500 text-hint">{{ errors[0] }}</span>
                              <span class="text-red-500 text-hint" v-for="(error, index) in validationErrors['businessName']" :key="index">{{ error }}</span>
                            </div>
                          </ValidationProvider>
                        </div>
                       <div class="flex items-center mt-4">
                              <h2 class="flex-1 text-base text-black text-right">
                                  Business/Organization Name
                              </h2>
                              <input
                                  type="text"
                                  v-model="formData.businessName"
                                  class="rounded-lg w-5/6 ml-4"
                                  :placeholder="user.org_name"
                              />
                        </div>
                -->

                    <div class="mb-3 space-7-4 ml-20 mt-14">
                        <div>
                        <h3>Job Title</h3>
                        </div>
                        <t-rich-select
                            v-model="profession"
                            :options="professions"
                            class= "w-3/5"
                            :textAttribute="'tag'"
                            noResultsText="Can't find your profession? you'll be able to create a new one in future releases of salesium"
                        />
                        <div class="opacity-0">spacer</div>
                        <div>
                            <h3>Business Address</h3>
                            <div class="group">Walkins Welcome <t-checkbox name="options" v-model="walkinsWelcome" />
                                <div class="italic">(if checked, we will display your street address)</div>
                            </div>
                        <input
                            type="text"
                            v-model="businessLocationData.address1"
                            class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                            placeholder="Address Line 1"
                        />
                        <input
                            type="text"
                            v-model="businessLocationData.address2"
                            class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                            placeholder="Address Line 2"
                        />
                        <ValidationProvider rules="required|digits:5" v-slot="{ errors }">
                                <div>
                                    <input
                                        type="text"
                                        id="postal_code"
                                        name="ZipCode"
                                        v-model="businessLocationData.postal_code"
                                        @change="updatePostalCode"
                                        class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                                        placeholder="ZipCode (5 digit)"
                                        autocomplete="postal_code"
                                    /><span class="text-red-500 ml-3">*</span>
                                    <span id="error" class="text-red-500 italic">{{ errors[0] }}</span>
                                </div>
                        </ValidationProvider>
                        <input
                            type="text"
                            name="City"
                            v-model="businessLocationData.city"
                            class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                            placeholder="City"
                            :disabled="1"
                            />

                        <ValidationProvider rules="alpha|length:2" v-slot="{ errors }">
                            <input
                                type="text"
                                name="StateOrProvince"
                                v-model="businessLocationData.state_province"
                                class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                                placeholder="State or Province"
                                :disabled="1"
                            />
                            <span id="error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>

            <div>

                <div class="text-center">
                    <button
                        type="submit"
                        class="primary-btn mt-14 px-12"
                        :disabled="invalid|submitting"
                    >
                        Go Pro
                    </button>
                </div>
            </div>
            </form>

        </div>
      </article>
    </div>
  </div>
    </ValidationObserver>
</template>
<script>
import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import {alpha, digits, length } from 'vee-validate/dist/rules';

//extend( 'required', required);
extend( 'alpha', alpha);
extend( 'digits', digits);
extend( 'length', length);

export default {
  props:["user", "professions"],
  data() {
    return {
        submitting: false,
        businessLocationData: this.user.business_location
            ? this.user.business_location
            : {
                address1: '',
                address2: '',
                city: null,
                state_province: null,
                postal_code: ''
            },
        profession: this.user.profession, // aka subIndustry
        locationType: 'Business',
        walkinsWelcome: this.user.walkins_welcome,
    };
  },
  methods: {
      async updatePostalCode(){
          let response = await window.axios.post( '/api/locations/postalCodeToCityState', {
              postal_code: this.businessLocationData.postal_code
          }).catch( err=>{
              console.error('ERROR:', err.response.data.message);
              this.errors = err.response.data.errors;
              this.formPosition = 0;
          });
          if( response.status == 200){
              this.businessLocationData.city = response.data.data.city;
              this.businessLocationData.state_province = response.data.data.state;
          }
//          console.log( this.businessLocationData.city);
//          console.log( this.businessLocationData.state_province);
      },
    async submitChanges() {
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
            this.submitting = true;
            // save core user data
            console.log('saving core data');
            let response = await window.axios.post('/api/user', {
                subindustry_id: this.profession,
                type: 'pro',
                walkins_welcome: this.walkinsWelcome
            }).catch(err => {
                console.error('ERROR:', err.response.data.message);
                if (err.response.status === 422) {
                    this.errors = err.response.data.errors;
                    this.formPosition = 0;
                    this.submitting = false;
                }
            });
            console.log('saving business location data');
            // save business location info
            response = await axios.put(`/api/locations/business/${this.user.id}`, {
                business_location: this.businessLocationData,
            }).then((response) => {
                //              this.leafletData.lat = response.data.data[0];
                //            this.leafletData.lng = response.data.data[1];
                //            this.locationSaving = false;
                //            this.$toasted.global.toast_success('Location updated successfully!');
                //            this.editingLocation = false;
            }).catch(err => {
                console.error('ERROR', err.response.data.message);
                this.submitting = false;
            });

            let redirect = '/pro-registration-choice';
            window.location.href = redirect;
//            this.$toasted.global.toast_success('Successfully signed up!');
        }
    }
  },
  components: {
      ValidationProvider,
      ValidationObserver
  }
};
</script>

<style scoped>
.animation-in {
  transform-origin: left;
  animation: in 0.6s ease-in-out;
}
.animation-out {
  transform-origin: bottom left;
  animation: out 0.6s ease-in-out;
}
</style>
